import React, { Component } from 'react';
import { Form, Control } from 'react-redux-form';
import validators from '../../../helpers/validators';
import { last, sortBy } from 'lodash';

import Textfield from '../../ui/text-field';
import Textarea from '../../ui/textarea';
import Select from '../../ui/select';
import Modal from '../../ui/modal';

import validObj from '../../../helpers/validateObj';
import aaSave from '../../../helpers/afterActionSave';

import aaValidation from '../../../helpers/afterActionValidation';

class Questions extends Component {
    handleSubmit = e => {
        const formObj = validObj(e);
        formObj.id = formObj.reportId;
        switch (this.props.userAction) {
            case 'save':
                formObj.deliverable = formObj.aadeliverable;
                formObj.recommend = formObj.aaRecommend;
                formObj.approverId = formObj.aaApproverId;
                this.props.updateAfterAction(formObj);
                break;
            case 'submit':
                const notValid = aaValidation(e);
                if (!notValid) {
                    formObj.deliverable = formObj.aadeliverable;
                    formObj.recommend = formObj.aaRecommend;
                    this.props.submitAfterAction(formObj);
                } else {
                    this.props.setEventErrorMessage(notValid);
                    if (e.aaawareness !== true && e.aabehavior !== true) {
                        this.props.setFormFieldValidity(
                            'event.aaawareness',
                            false
                        );
                        this.props.setFormFieldValidity(
                            'event.aabehavior',
                            false
                        );
                    } else if (
                        e.aaawareness === true ||
                        e.aabehavior === true
                    ) {
                        this.props.setFormFieldValidity(
                            'event.aaawareness',
                            true
                        );
                        this.props.setFormFieldValidity(
                            'event.aabehavior',
                            true
                        );
                    }
                }
                break;
            case 'approve':
                this.props.approveAfterAction(formObj);
                break;
            case 'request':
                this.props.requestInfoAfterAction(formObj);
                break;
            default:
                console.log(this.props.userAction);
        }
    };

    handleSubmitFailed = e => {
        if (this.props.userAction === 'save') {
            const values = aaSave(e);
            this.props.updateAfterAction(values);
        }
        if (this.props.userAction === 'request') {
            const values = aaSave(e);
            this.props.requestInfoAfterAction(values);
        }
    };

    render() {
        let saveSubmit = false;
        let approveReject = false;
        let userInfo = this.props.userInfo;
        const trustingUserId = userInfo.TrustingUser
            ? userInfo.TrustingUser.id
            : null;

        if (
            this.props.groupStatus.status === 'After Action Incomplete' ||
            this.props.groupStatus.status === 'After Action Pending'
        ) {
            if (
                this.props.afterActionUserID === this.props.userInfo.id ||
                this.props.afterActionUserID === trustingUserId
            ) {
                saveSubmit = true;
            }
        } else if (
            this.props.eventState.EventReport.status === 'Unapproved' &&
            this.props.groupStatus.status === 'After Action Review' &&
            this.props.tasks &&
            this.props.tasks.length > 0
        ) {
            const mostRecentTask = last(sortBy(this.props.tasks, 'id'));
            if (mostRecentTask.userId === this.props.userInfo.id) {
                if (mostRecentTask.action === 'Info') {
                    saveSubmit = true;
                } else {
                    approveReject = true;
                }
            }
        }

        let required = validators.empty();
        let textVal = validators.trimVal();

        return (
            <Form
                className="form"
                model="event"
                encType="multipart/form-data"
                onSubmit={this.handleSubmit}
                onSubmitFailed={this.handleSubmitFailed}
            >
                <div className="tab__title">Questions</div>

                <div className="first-col">
                    <Select
                        model="event.attended"
                        isRequired
                        title="Did the MAC attend the event?"
                        options={[
                            { name: 'Yes', code: '1' },
                            { name: 'No', code: '0' }
                        ]}
                        validators={saveSubmit ? { required } : undefined}
                        messages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                    />

                    <Textfield
                        model="event.marinesAttendance"
                        isRequired
                        title="How many Marines attended the event?"
                        type="number"
                        validators={saveSubmit ? { textVal } : undefined}
                        messages={
                            saveSubmit
                                ? { textVal: textVal.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                        onKeyPress
                        min="0"
                    />

                    <Select
                        model="event.electricity"
                        isRequired
                        title="Was electricity needed at this event?"
                        options={[
                            { name: 'Yes', code: '1' },
                            { name: 'No', code: '0' }
                        ]}
                        validators={saveSubmit ? { required } : undefined}
                        messages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                    />

                    <Select
                        model="event.accommodating"
                        isRequired
                        title="Was the staff accommodating to the Marines?"
                        options={[
                            { name: 'Yes', code: '1' },
                            { name: 'No', code: '0' }
                        ]}
                        validators={saveSubmit ? { required } : undefined}
                        messages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                    />

                    <Select
                        model="event.aaRecommend"
                        isRequired
                        title="Would you recommend repeating this event?"
                        options={[
                            { name: 'Yes', code: '1' },
                            { name: 'No', code: '0' }
                        ]}
                        validators={saveSubmit ? { required } : undefined}
                        messages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                    />

                    <Select
                        model="event.emvAttend"
                        isRequired
                        title="Did the EMV team attend this event?"
                        options={[
                            { name: 'Yes', code: '1' },
                            { name: 'No', code: '0' }
                        ]}
                        validators={saveSubmit ? { required } : undefined}
                        messages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                    />
                </div>

                <div className="second-col">
                    <Textarea
                        model="event.keyParticipants"
                        isRequired
                        title="What other key participants were at this event?"
                        validators={saveSubmit ? { textVal } : undefined}
                        messages={
                            saveSubmit
                                ? { textVal: textVal.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                        maxLength={1000}
                    />

                    <Textarea
                        model="event.problems"
                        isRequired
                        title="Were there any problems or situations unique to this event that you (or someone else) will need to be prepared for next year?"
                        validators={saveSubmit ? { textVal } : undefined}
                        messages={
                            saveSubmit
                                ? { textVal: textVal.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                        maxLength={1000}
                    />

                    <Textarea
                        model="event.comments"
                        isRequired
                        title="Comments"
                        validators={saveSubmit ? { textVal } : undefined}
                        messages={
                            saveSubmit
                                ? { textVal: textVal.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                        maxLength={1000}
                    />
                </div>

                <Control.text
                    model="event.hidden"
                    type="hidden"
                    value="eventId"
                    disabled={!saveSubmit}
                />

                <div className="form__actions form__actions--global">
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--secondary btn--save"
                            type="submit"
                            model="event.userActionTaken"
                            value="save"
                            onClick={() => {
                                this.props.setEventUserAction('save');
                            }}
                        >
                            Save
                        </Control.button>
                    ) : null}
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--submit"
                            type="submit"
                            model="event.userActionTaken"
                            value="submit"
                            onClick={() => {
                                this.props.setEventUserAction('submit');
                            }}
                        >
                            Submit
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Control.button
                            className="btn btn--secondary"
                            type="submit"
                            model="event.userActionTaken"
                            value="approve"
                            onClick={() => {
                                this.props.setEventUserAction('approve');
                            }}
                        >
                            Approve
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Modal
                            title="Returned for Edit"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.requestModalActive}
                            toggleModal={this.props.toggleRequestModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'request'}
                        >
                            <div className="form__section-title">
                                Returned for Edit
                            </div>
                            <Textfield
                                model="event.aaRequestComments"
                                title="Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                </div>
            </Form>
        );
    }
}

export default Questions;



// WEBPACK FOOTER //
// ./src/components/event/after-action/questions.js